import type { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';
import ListCardCell from '../ListCardCell';

const alignmentClasses = {
    start: 'text-left',
    center: 'text-center',
    end: 'text-right',
} as const;

type AlignmentKey = keyof typeof alignmentClasses;

interface ListActionCellProps extends ComponentPropsWithoutRef<typeof ListCardCell> {
    alignment?: AlignmentKey;
    withDivider?: boolean;
}

const dividerClasses = 'relative before:block before:w-px before:h-8 before:bg-neutro-300 before:absolute before:left-0 before:inset-y-0 before:my-auto before:dark:bg-white/15';

export default function ListActionCell({ className, alignment = 'end', withDivider = false, ...props }: ListActionCellProps) {
    return (
        <ListCardCell
            {...props}
            className={twMerge([
                'py-0',
                alignmentClasses[alignment],
                withDivider ? dividerClasses : undefined,
                className,
            ])}
        />
    );
}
